export default __webpack_public_path__ + "static/cross-border-remittance-company-peerbits-0a4192edbdb25ba7bd124cf556b9a23e.png";